<article>
  <div class="row text-center">
    <div class="mx-auto text-left">
      <div>
        <app-form action="/account/confirmation-required" [handler]="this">
          <input type="hidden" name="user_id" value="{{userId}}" />

          <h1>Confirmation Required</h1>
          <p>You must confirm your account before logging in. Click the link in the confirmation email or
            click below to resend it.</p>

          <div class="actions">
            <a class="btn" routerLink="/login">Try Again</a>
            <button class="sign-in btn btn-primary mx-auto">Resend Email</button>
            <a class="btn" href="javascript:;" (click)="close()">Close</a>
          </div>

          <tyt-staging-note [shown]="true">
            This is the staging installation, your account details are not synchronized with the production system.
            Your email address may be different than on TYTnetwork.com. You can also sign up and create additional
            test accounts to test different parts of the system.
          </tyt-staging-note>
        </app-form>
      </div>
    </div>
  </div>
</article>